import { useState } from "react";
import { useCart } from "../context/CartContext";
import CartDrawer from "./CartDrawer";
import FavouritesDrawer from "./FavouritesDrawer";

export default function Navbar() {
  const { cart, favourites } = useCart();

  const [openCart, setOpenCart] = useState(false);
  const [openFavs, setOpenFavs] = useState(false);

  return (
    <>
      <nav className="fixed top-0 left-0 w-full bg-white shadow z-[3000] h-[80px] flex items-center justify-between px-6">


        <h1 className="text-lg font-bold">Dimpex Jewellery</h1>

        <div className="flex items-center gap-4">
          {/* FAV BUTTON */}
          <button onClick={() => setOpenFavs(true)} className="relative text-2xl cursor-pointer" >
            ❤️
            {favourites.length > 0 && (
              <span className="absolute -top-2 -right-2 bg-red-600 text-white text-xs rounded-full px-1">
                {favourites.length}
              </span>
            )}
          </button>

          {/* CART BUTTON */}
          <button onClick={() => setOpenCart(true)} className="relative text-2xl cursor-pointer">
            🛒
            {cart.length > 0 && (
              <span className="absolute -top-2 -right-2 bg-indigo-600 text-white text-xs rounded-full px-1">
                {cart.length}
              </span>
            )}
          </button>
        </div>
      </nav>

      <CartDrawer open={openCart} close={() => setOpenCart(false)} />
      <FavouritesDrawer open={openFavs} close={() => setOpenFavs(false)} />
    </>
  );
}
